if (!customElements.get('floating-cart-button')) {
  customElements.define(
    'floating-cart-button',
    class FloatingCartButton extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('[data-floating-cart-trigger]');
        this.count = this.querySelector('[data-floating-cart-count]');
        this.a11yText = this.querySelector('[data-floating-cart-a11y]');

        this.trigger?.addEventListener('click', this.onTriggerClick.bind(this));
        this.trigger?.addEventListener('keydown', this.onTriggerKeydown.bind(this));

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeCartUpdate = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => this.onCartUpdate(event));
        }
      }

      disconnectedCallback() {
        this.unsubscribeCartUpdate?.();
      }

      onTriggerClick(event) {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer) return;

        event.preventDefault();
        drawer.open(this.trigger);
      }

      onTriggerKeydown(event) {
        if (event.code.toUpperCase() !== 'SPACE') return;
        const drawer = document.querySelector('cart-drawer');
        if (!drawer) return;

        event.preventDefault();
        drawer.open(this.trigger);
      }

      onCartUpdate(event) {
        if (event?.cartData?.item_count !== undefined) {
          this.updateCount(event.cartData.item_count);
          return;
        }

        fetch(`${routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cart) => this.updateCount(cart.item_count))
          .catch(() => {});
      }

      updateCount(itemCount) {
        if (!this.count) return;

        const count = Number(itemCount) || 0;
        this.count.textContent = count > 99 ? '99+' : count;
        this.count.classList.toggle('hidden', count === 0 && this.dataset.showEmptyCount !== 'true');

        if (this.a11yText) {
          this.a11yText.textContent = count === 1 ? '1 item in cart' : `${count} items in cart`;
        }
      }
    }
  );
}
